import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ProgressCircle from 'contest/components/progress-circle';
import onboardingInfoBox from 'contest/components/onboarding-prompts/onboardingInfoBox';

export default onboardingInfoBox('brief-score', ({ score }) => (
    <div className="flag flag--top">
        <div className="flag__mast">
            <ProgressCircle percentage={score} />
        </div>
        <div className="flag__flag">
            <p className="paragraph paragraph--wide">
                <FormattedHTMLMessage id="infobox_text" />
            </p>
            <FormattedHTMLMessage id="infobox_link" />
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/BriefScoreInfoBox.js